import { createSlice, PayloadAction } from "@reduxjs/toolkit"

const initialState: { value: string[] } = {
  value: []
}

const operatorConnectedSlice = createSlice({ 
  name: "operator_connected_slice",
  initialState,
  reducers: {
    merge: (state, action: PayloadAction<string[]>) => {
      state.value = action.payload.filter(i => !state.value.includes(i)).concat(state.value)
    },
    pop: (state, action: PayloadAction<string[]>) => {
      state.value = action.payload
    }
  }
})

export const { merge, pop } = operatorConnectedSlice.actions
export const operator_connected_slice = operatorConnectedSlice.reducer